var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasFacture)?_c('router-link',{attrs:{"to":{name: 'market-billing-detail', params: {uid: _vm.object.facture}}}},[_vm._v(" "+_vm._s(_vm.facture.invoiceNumber)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }